'use client';

import { useEffect, useState } from 'react';
import { SwitcherChartSlice } from '../../../../../prismicio-types';

import { ChartData } from '@/types';
import { Bar, YAxis } from './index';
import styles from './barChart.module.scss';

interface BarChartProps {
  slice: SwitcherChartSlice;
  activeTab: number;
}

export const BarChart = ({ slice, activeTab }: BarChartProps) => {
  const [chartData, setChartData] = useState<ChartData[]>([]);
  const [maxValue, setMaxValue] = useState<number>(0);
  const [isFirstTab, setIsFirstTab] = useState<boolean>(true);

  const creditScoreData = slice.primary.by_credit_score_chart_data;
  const incomeRangeData = slice.primary.by_income_range_chart_data;

  const creditLabels = slice.primary.by_credit_score_chart_labels;
  const incomeLabels = slice.primary.by_income_range_chart_labels;

  useEffect(() => {
    setChartData(
      creditScoreData.map((item, index) => ({
        value: {
          credit: item.value,
          income: incomeRangeData[index].value,
        },
        indicator: {
          credit: item.indicator,
          income: incomeRangeData[index].indicator,
        },
        label: {
          credit: creditLabels[index].value,
          income: incomeLabels[index].value,
        },
        unit: {
          credit: item.unit,
          income: incomeRangeData[index].unit,
        },
      }))
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setIsFirstTab(activeTab === 0);
  }, [activeTab]);

  useEffect(() => {
    setMaxValue(
      Math.ceil(
        Math.max(
          ...chartData.map((item) =>
            Number(
              item.value.credit! > item.value.income!
                ? item.value.credit
                : item.value.income
            )
          )
        ) / 200
      ) * 200
    );
  }, [chartData]);
  return (
    <div className={styles.list_wrapper}>
      {chartData.length > 0 && (
        <ul className={styles.list}>
          {chartData.map((data) => (
            <Bar
              data={data}
              maxValue={maxValue}
              key={`${data.indicator.credit} ${data.label.credit}`}
              isFirstTab={isFirstTab}
            />
          ))}
        </ul>
      )}
      <YAxis maxValue={maxValue} />
    </div>
  );
};
